import { render, staticRenderFns } from "./LoadingSkeleton.ts.vue?vue&type=template&id=e9264e54"
var script = {}
import style0 from "./LoadingSkeleton.ts.vue?vue&type=style&index=0&id=e9264e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports